import { SvgIcon } from '@mui/material';
import { IconProps } from './types/iconTypes';
export default function CheckCircleIcon({
  color = '#027356',
  width = '64',
  height = '64',
  className
}: IconProps) {
  return <SvgIcon className={className} viewBox={`0 0 ${width} ${height}`} sx={{
    width: `${width}px`,
    height: `${height}px`
  }} data-sentry-element="SvgIcon" data-sentry-component="CheckCircleIcon" data-sentry-source-file="CheckCircleIcon.tsx">
			<path d="M32 5.3335C17.28 5.3335 5.33337 17.2802 5.33337 32.0002C5.33337 46.7202 17.28 58.6668 32 58.6668C46.72 58.6668 58.6667 46.7202 58.6667 32.0002C58.6667 17.2802 46.72 5.3335 32 5.3335ZM32 53.3335C20.24 53.3335 10.6667 43.7602 10.6667 32.0002C10.6667 20.2402 20.24 10.6668 32 10.6668C43.76 10.6668 53.3334 20.2402 53.3334 32.0002C53.3334 43.7602 43.76 53.3335 32 53.3335ZM44.24 20.2135L26.6667 37.7868L19.76 30.9068L16 34.6668L26.6667 45.3335L48 24.0002L44.24 20.2135Z" fill={color} data-sentry-element="path" data-sentry-source-file="CheckCircleIcon.tsx" />
		</SvgIcon>;
}